import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { getHomePageUrl, getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import LinksState from "@insite/client-framework/Store/Links/LinksState";
import translate from "@insite/client-framework/Translate";
import VmiPageTypes from "@insite/client-framework/Types/VmiPageTypes";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Breadcrumbs, { BreadcrumbsPresentationProps } from "@insite/mobius/Breadcrumbs";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { LinkProps } from "@insite/mobius/Link";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

import { COMMON, ELEMENTS, TYPOGRAPHY } from "@tSurya/theme/design";

interface OwnProps {
    extendedStyles?: PageBreadcrumbsStyles;
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        links: state.components.breadcrumbs.links,
        linksState: state.links,
        nodeId: getCurrentPage(state).nodeId,
        homePageUrl: getHomePageUrl(state),
        isProductDetailsPage: getCurrentPage(state).type === "ProductDetailsPage",
        isProductListPage: getCurrentPage(state).type === "ProductListPage",
        productState: getProductState(state, state.pages.productDetails.selectedProductId),
        location: getLocation(state),
    };
};

export interface PageBreadcrumbsStyles {
    breadcrumbs?: BreadcrumbsPresentationProps;
    pdpMobileBreadcrumbs: BreadcrumbsPresentationProps;
}

export const pageBreadcrumbStyles: PageBreadcrumbsStyles = {
    breadcrumbs: {
        css: css`
            /* Mobile Breadcrumb for all pages */
            max-width: ${COMMON.width.content}px;
            padding: ${ELEMENTS.breadcrumbs.padding};
            /* margin: 0 auto; */
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        overflow-x: auto;
                        overflow-y: hidden;
                        flex-wrap: nowrap;
                        white-space: nowrap;
                        scrollbar-width: none;

                        &::-webkit-scrollbar {
                            display: none;
                        }

                        > * {
                            flex-shrink: 0;
                        }
                    `,
                    css`
                        overflow-x: auto;
                        overflow-y: hidden;
                        flex-wrap: nowrap;
                        white-space: nowrap;
                        scrollbar-width: none;

                        &::-webkit-scrollbar {
                            display: none;
                        }

                        > * {
                            flex-shrink: 0;
                        }
                    `,
                    css`
                        overflow-x: auto;
                        overflow-y: hidden;
                        flex-wrap: nowrap;
                        white-space: nowrap;
                        scrollbar-width: none;

                        &::-webkit-scrollbar {
                            display: none;
                        }

                        > * {
                            flex-shrink: 0;
                        }
                    `,
                    null,
                    null,
                ])}
            &.mobile-breadcrumb {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                a {
                                    display: none;
                                    &:last-of-type {
                                        display: inline-flex;
                                    }
                                    &:before {
                                        content: "<";
                                        color: ${getColor("text.accent")};
                                        padding-right: 10px;
                                        font-size: 18px;
                                    }
                                    &.isNonClickable:before {
                                        display: none;
                                    }
                                }
                                .isNonClickable.mobileBreadcrumbLabel {
                                    display: inline-flex;
                                }
                                > span {
                                    display: none;
                                }
                            `,
                            css`
                                a {
                                    display: none;
                                    &:last-of-type {
                                        display: inline-flex;
                                    }
                                    &:before {
                                        content: "<";
                                        color: ${getColor("text.accent")};
                                        padding-right: 10px;
                                        font-size: 18px;
                                    }
                                    &.isNonClickable:before {
                                        display: none;
                                    }
                                }
                                .isNonClickable.mobileBreadcrumbLabel {
                                    display: inline-flex;
                                }
                                > span {
                                    display: none;
                                }
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    )}
            }
            .isNonClickable {
                pointer-events: none !important;
                cursor: default;
            }
        `,
    },
    pdpMobileBreadcrumbs: {
        css: css`
            /* Mobile Breadcrumb for all pages */
            padding: ${ELEMENTS.breadcrumbs.padding};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        box-sizing: border-box;
                        overflow-x: auto;
                        overflow-y: hidden;
                        flex-wrap: nowrap !important;
                        white-space: nowrap !important;
                        scrollbar-width: none;

                        &::-webkit-scrollbar {
                            display: none;
                        }

                        > * {
                            flex: 0 0 auto;
                        }
                    `,
                    css`
                        width: 100%;
                        box-sizing: border-box;
                        overflow-x: auto;
                        overflow-y: hidden;
                        flex-wrap: nowrap !important;
                        white-space: nowrap !important;
                        scrollbar-width: none;

                        &::-webkit-scrollbar {
                            display: none;
                        }

                        > * {
                            flex: 0 0 auto;
                        }
                    `,
                    css`
                        width: 100%;
                        box-sizing: border-box;
                        overflow-x: auto;
                        overflow-y: hidden;
                        flex-wrap: nowrap !important;
                        white-space: nowrap !important;
                        scrollbar-width: none;

                        &::-webkit-scrollbar {
                            display: none;
                        }

                        > * {
                            flex: 0 0 auto;
                        }
                    `,
                    null,
                    null,
                ])}
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        overflow-x: auto;
                        overflow-y: hidden;
                        flex-wrap: nowrap;
                        white-space: nowrap;
                        scrollbar-width: none;

                        &::-webkit-scrollbar {
                            display: none;
                        }

                        > * {
                            flex-shrink: 0;
                        }
                    `,
                    css`
                        overflow-x: auto;
                        overflow-y: hidden;
                        flex-wrap: nowrap;
                        white-space: nowrap;
                        scrollbar-width: none;

                        &::-webkit-scrollbar {
                            display: none;
                        }

                        > * {
                            flex-shrink: 0;
                        }
                    `,
                    css`
                        overflow-x: auto;
                        overflow-y: hidden;
                        flex-wrap: nowrap;
                        white-space: nowrap;
                        scrollbar-width: none;

                        &::-webkit-scrollbar {
                            display: none;
                        }

                        > * {
                            flex-shrink: 0;
                        }
                    `,
                    null,
                    null,
                ])}
            a {
                text-decoration: none;
            }

            > span.hide:nth-child(4) {
                display: none;
            }
            > span.hide:nth-child(6) {
                display: none;
            }
            > span:last-child {
                a {
                    color: ${getColor("text.link")};
                }

                color: ${getColor("text.link")};
                font-weight: ${TYPOGRAPHY.breadcrumbs.weight} !important;
                opacity: 1;
                font-size: 14px;
            }

            > a.isNonClickable:first-child {
                pointer-events: none !important;
            }
            > a.isNonClickable:nth-child(3) {
                pointer-events: none !important;
                display: none;
            }

            max-width: ${COMMON.width.content}px;
            /* margin: 0 auto; */
            &.mobile-breadcrumb {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                a {
                                    display: flex;
                                    &:last-of-type {
                                        display: flex;
                                    }
                                }
                                > span {
                                    display: flex;
                                }
                            `,
                            css`
                                a {
                                    display: flex;
                                    &:last-of-type {
                                        display: flex;
                                    }
                                }
                                > span {
                                    display: flex;
                                }
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    )}
            }
        `,
    },
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const PageBreadcrumbs = (props: Props) => {
    const pathName = props.location?.pathname?.toLowerCase();
    let links = props.links || generateLinksFrom(props.linksState, props.nodeId, props.homePageUrl);
    const styles = useMergeStyles("pageBreadcrumbs", pageBreadcrumbStyles, props.extendedStyles);

    React.useEffect(() => {
        if (typeof window !== "undefined") {
            const selectStateEl: HTMLSelectElement | null = document.querySelector('[data-test-selector="pageBreadcrumbs"]');
            if (selectStateEl) {
                selectStateEl.classList.add("mobile-breadcrumb");
            }
        }
    });

    if (links.length > 0 && links.some(o => o.type === "HomePage" || o.type === undefined)) {
        // we need to always direct to the language-specific homepage URL
        const homePageLink = { children: translate("Home_Breadcrumb"), href: props.homePageUrl };
        const linksWithoutHomePageLink = [...links].splice(1, links.length);
        // links = [homePageLink, ...linksWithoutHomePageLink];
        links = [...linksWithoutHomePageLink];
    }
    if (links.length === 1) {
        return null;
    }

    return (
        <>
            {props.isProductDetailsPage ? (
                <Breadcrumbs
                    links={links}
                    data-test-selector="pageBreadcrumbs"
                    {...styles.pdpMobileBreadcrumbs}
                    isProductDetailsPage={props.isProductDetailsPage}
                    productBrand={props.productState?.value?.brand?.name}
                    brandUrl={props.productState?.value?.brand?.detailPagePath}
                    isProductListPage={props?.isProductListPage}
                    pathName={pathName}
                />
            ) : (
                <Breadcrumbs
                    links={links}
                    data-test-selector="pageBreadcrumbs"
                    {...styles.breadcrumbs}
                    isProductDetailsPage={props.isProductDetailsPage}
                    productBrand={props.productState?.value?.brand?.name}
                    brandUrl={props.productState?.value?.brand?.detailPagePath}
                    isProductListPage={props?.isProductListPage}
                    pathName={pathName}
                />
            )}
        </>
    );
};

export function generateLinksFrom(linksState: LinksState, nodeId: string, homePageUrl: string) {
    const links: LinkProps[] = [];
    let currentLink = getPageLinkByNodeId({ links: linksState }, nodeId);
    const vmiExcludePageTypes: string[] = ["HomePage", "MyAccountPage"];
    const search = (targetText: string) => (sourceTextArray: string) => sourceTextArray === targetText;
    const isVmiPageType = !currentLink?.type ? false : VmiPageTypes.some(search(currentLink.type));
    while (currentLink) {
        const isVmiExcludePageType = !currentLink?.type ? false : vmiExcludePageTypes.some(search(currentLink.type));
        if (!isVmiPageType || !isVmiExcludePageType) {
            links.unshift({
                children: currentLink.type === "HomePage" ? translate("Home_Breadcrumb") : currentLink.title,
                href: currentLink.url,
                type: currentLink.type,
            });
        }
        currentLink = currentLink.parentId ? getPageLinkByNodeId({ links: linksState }, currentLink.parentId) : undefined;
    }

    return links;
}

export default connect(mapStateToProps)(PageBreadcrumbs);
